import { createSingleton } from '@luna/utils';
import { logger } from '@luna/logger';

export type TrackerRouterOptions = {
    getRoute: () => string;
    getNormalizedRoute: () => string;
};

/**
 * Different apps can have different methods to get
 * the current page due to different routers.
 * This singleton is to be set with callbacks by each Application shells
 * router to get the current page name and source.
 * */
const trackerRouterOptions = createSingleton<TrackerRouterOptions>({
    getRoute: () => {
        logger.warn('Tracker Router Options for getting route is not initialized');
        return '';
    },
    getNormalizedRoute: () => {
        logger.warn('Tracker Router Options for getting normalized route is not initialized');
        return '';
    },
});

export const getTackerRouterOptions = trackerRouterOptions.get;
/**
 * @remark To be invoked by the application shells only.
 * */
export const setTrackerRouterOptions = (options: TrackerRouterOptions) => {
    trackerRouterOptions.set(options);
};
